import { AppId } from '@inno-tools/container-bridge'
import { FullPageAppTemplate } from 'modules/app-registry/templates'
import { useLocation, useNavigate } from 'react-router-dom'
import { useUserContext } from 'shared/hooks'

import { useAvailableApps } from '../hooks/useAvailableApps'

export const RecruitingAgentApp = () => {
  const navigate = useNavigate()
  const location = useLocation()
  const { user } = useUserContext()
  const { apps } = useAvailableApps()

  return (
    <FullPageAppTemplate
      appId={AppId.RECRUITING_AGENT}
      scope='recruiting_agent'
      envKey={apps[AppId.RECRUITING_AGENT].runtimeEnvKey}
      entryPath='./RecruitingAgentApp'
      url={process.env.REACT_APP_RECRUITING_AGENT_APP_DEV_PATH}
      appName={apps[AppId.RECRUITING_AGENT].name}
      appProps={{
        // No `history` here on purpose: recruiter-agent-fe's bootstrap
        // ignores it and expects a plain BrowserRouter basename, not the
        // container's HistoryRouter.
        user,
        appPath: apps[AppId.RECRUITING_AGENT].path,
        initialPath: location.pathname,
        onNavigate: ({ pathname: nextPathname }: { pathname: string }) => {
          const { pathname } = location

          if (pathname !== nextPathname) {
            navigate(nextPathname)
          }
        }
      }}
    />
  )
}
